import React, { useEffect, useState } from 'react';
import ProjectTask from './ProjectTask/ProjectTask';
import AddProjectTask from './AddProjectTask';
import ProjectAPIs from '../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs';
import { useNavigate, useParams } from 'react-router-dom';
import './ViewProjectTasks.css';
import StageSelectionTabs from '../../../../../StageSelectionTabs/StageSelectionTabs';
import { Card, Row, Col } from 'react-bootstrap';
import { MdAddCircle } from 'react-icons/md';
import ViewProjectTabs from '../ViewProjectTabs/ViewProjectTabs';

export default function ViewProjectTasks(){

    const params = useParams();
    const navigate = useNavigate();

    

    const [stageID, setStageID] = useState('');
    const [addNew, setAddNew] = useState(false);

    const [projectTasks, setProjectTasks] = useState([]);

    

    const getProjectTasks = (projectID) => {

        ProjectAPIs.GetProjectTasks(projectID)
        .then((projectTasks) => {
            setProjectTasks(projectTasks.data);
        })
        .catch((err) => {
            console.log(err)
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                }
            }
        })
    }

    const handleAddNew = () => {
        setAddNew(false);
        getProjectTasks(params.ProjectID);
    }

    const tabs = [
        { key: "all", label: `All Tasks (${projectTasks.length})`, component: projectTasks.map((task) => <ProjectTask key={task.id} projectTaskID={task.id} getProjectTasks={getProjectTasks}/>) },
        { key: "stage-one", label: `Stage One (${projectTasks.filter((task) => parseInt(task.task.stage_id) === 1).length})`, component: projectTasks.filter((task) => parseInt(task.task.stage_id) === 1).map((task) => <ProjectTask key={task.id} projectTaskID={task.id} getProjectTasks={getProjectTasks}/>) },
        { key: "stage-two", label: `Stage Two (${projectTasks.filter((task) => parseInt(task.task.stage_id) === 2).length})`, component: projectTasks.filter((task) => parseInt(task.task.stage_id) === 2).map((task) => <ProjectTask key={task.id} projectTaskID={task.id} getProjectTasks={getProjectTasks}/>) },
        { key: "stage-three", label: `Stage Three (${projectTasks.filter((task) => parseInt(task.task.stage_id) === 3).length})`, component: projectTasks.filter((task) => parseInt(task.task.stage_id) === 3).map((task) => <ProjectTask key={task.id} projectTaskID={task.id} getProjectTasks={getProjectTasks}/>) },
        { key: "stage-four", label: `Stage Four (${projectTasks.filter((task) => parseInt(task.task.stage_id) === 4).length})`, component: projectTasks.filter((task) => parseInt(task.task.stage_id) === 4).map((task) => <ProjectTask key={task.id} projectTaskID={task.id} getProjectTasks={getProjectTasks}/>) },
       
        
    ];

    useEffect(() => {
        getProjectTasks(params.ProjectID);
    }, [params.ProjectID]);

    return(
        <div className='project-tasks-container'>
            
            {/* add button here */}

            <AddProjectTask handleAddNew={handleAddNew} />

            <ViewProjectTabs tabs={tabs} />


            {/* <StageSelectionTabs value={stageID} setStageValue={setStageID} />
            {stageID > 0 ? 
            
            projectTasks.filter((task) => parseInt(task.task.stage_id) === parseInt(stageID))
            .map((task) => {
                    return(
                        <ProjectTask key={task.id} projectTaskID={task.id} getProjectTasks={getProjectTasks}/>
                    )
                }
                
            )
                :
                projectTasks.map((task) => {
                    return(
                        <ProjectTask key={task.id} projectTaskID={task.id} getProjectTasks={getProjectTasks}/>
                    )
                })
        } */}
                

        

        </div>
    )

}